import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const BarGraph18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path d='M15.75 1H14.25V13H15.75V1Z' fill='currentColor' />
    <path d='M2.25 13V9H3.75V13H2.25Z' fill='currentColor' />
    <path d='M0 15.25H18V16.75H0V15.25Z' fill='currentColor' />
    <path d='M7.75 4V13H6.25V4H7.75Z' fill='currentColor' />
    <path d='M11.75 13V7H10.25V13H11.75Z' fill='currentColor' />
  </Svg>
);

BarGraph18.displayName = 'BarGraph18';
export default BarGraph18;
